var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTfilin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.896,
    height: 37.24,
    viewBox: "0 0 35.896 37.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1173",
    x: 1.236,
    y: 2.528,
    width: 34.661,
    height: 30.32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0e1e43",
    floodOpacity: 0.188
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.502,
    y1: 0.725,
    x2: 0.469,
    y2: -0.3,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.322,
    y1: 1.482,
    x2: 0.694,
    y2: -0.095,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80949b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.864,
    y1: -0.188,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.655,
    x2: 0.293,
    y2: 0.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85a1a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.861,
    x2: 0.343,
    y2: 1.083,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1,
    y1: -0.105,
    x2: 0.372,
    y2: 0.697,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 1.52,
    x2: 0.488,
    y2: -0.18,
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(0 -2.485)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 2.48)",
    filter: "url(#Path_1173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173-2",
    "data-name": "Path 1173",
    d: "M1693.855,333.436l-4.008-5.968,2.337-4.792-6.339-9.443-11.362.79v.01h-.021l-3.916,8.031-6.7.868-1.9,3.691,10.422,14.93,8.291-.478,13.166-1.426,1.782-3.644Z",
    transform: "translate(-1659.72 -310.7)",
    fill: "#00cbff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 12.538, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M.086,1.9,0,5.656l14.583,8.028L31.976,3.7V0L14.583,9.981Z",
    transform: "translate(0 14.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M17.83,16.715V5.147L8.915,0,0,5.147V16.715l8.915,5.147Z",
    transform: "translate(5.668 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M9.343,0,0,5.426.517,16.294l8.8-5.083Z",
    transform: "translate(14.093 5.381)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(5.239 6.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M0,.836,3.726.358l.02.031L6.631,0,5.263,2.729l5.563,8.579,10.282-.627,2.872-5.7,3.664,5.3h.019l1.811,2.767-19.891,1.6Z",
    transform: "translate(0 7.987)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M88.5-974.469l-10.279.714,5.205,8.614,10.781-.74Z",
    transform: "translate(-68.068 974.469)",
    opacity: 0.64,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M85.944-960.972l-1.131,2.6,9.506-.668-5.492-8.207Z",
    transform: "translate(-64.825 980.053)",
    opacity: 0.64,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M76.085-970.906,73.146-964.9,69.8-970.124Z",
    transform: "translate(-69.587 978.893)",
    opacity: 0.65,
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M96.079-959.109,75.9-957.848l-.391.913,20.114-1.289Z",
    transform: "translate(-67.775 982.633)",
    opacity: 0.66,
    fill: "url(#linear-gradient-7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfilin);
export default __webpack_public_path__ + "static/media/tfilin.e38a8e00e54ecdbbbc1cdc2252da778b.svg";
export { ForwardRef as ReactComponent };